import { SvgIcon, SxProps } from "@mui/material";
import SvgThumbsUpIcon from "jsx:../../../Images/Icons/FontAwesome/solid/thumbs-up.svg";

export function ThumbsUpSolidIcon(props: SxProps) {
    return (
        <SvgIcon
            component={SvgThumbsUpIcon}
            inheritViewBox
            data-testid={"ThumbsUpIcon"}
            sx={props}
        />
    );
}
